export const messages = {
  en: {
    signRule: {
      title: 'Sign Rule Management',
      addTitle: 'Add Sign Rule',
      editTitle: 'Edit Sign Rule',
      deleteTitle: 'Delete Sign Rule',
      confirmDelete: 'Are you sure to delete this sign rule?',
      ruleNameRequired: 'Rule name is required',
      cycleDaysRequired: 'Cycle days is required',
      table: {
        ruleId: 'Rule ID',
        ruleName: 'Rule Name',
        cycleDays: 'Cycle Days',
        rewardAmount: 'Reward Amount',
        extraRewardAmount: 'Extra Reward Amount',
        remark: 'Remark'
      },
      placeholder: {
        ruleName: 'Please enter rule name',
        cycleDays: 'Please enter cycle days',
        rewardAmount: 'Please enter reward amount',
        extraRewardAmount: 'Please enter extra reward amount',
        remark: 'Please enter remark'
      }
    },
    signAccount: {
      title: 'Sign Account Management',
      queryCondition: 'Query Condition',
      table: {
        accountId: 'Account ID',
        personId: 'Person ID',
        personName: 'Person Name',
        totalDays: 'Total Days',
        continueDays: 'Continue Days',
        lastSignDate: 'Last Sign Date',
        cycleNum: 'Cycle Number',
        createTime: 'Create Time'
      },
      placeholder: {
        personName: 'Please enter person name',
        personId: 'Please enter person ID'
      }
    },
    signRecord: {
      title: 'Sign Record Management',
      queryCondition: 'Query Condition',
      table: {
        recordId: 'Record ID',
        accountId: 'Account ID',
        personId: 'Person ID',
        personName: 'Person Name',
        signDate: 'Sign Date',
        signType: 'Sign Type',
        rewardAmount: 'Reward Amount',
        rewardDesc: 'Reward Description',
        remark: 'Remark',
        createTime: 'Create Time'
      },
      placeholder: {
        personName: 'Please enter person name',
        personId: 'Please enter person ID',
        signDate: 'Please enter sign date'
      }
    }
  },
  zh: {
    signRule: {
      title: '签到规则管理',
      addTitle: '添加签到规则',
      editTitle: '修改签到规则',
      deleteTitle: '删除签到规则',
      confirmDelete: '确定要删除这条签到规则吗？',
      ruleNameRequired: '规则名称不能为空',
      cycleDaysRequired: '周期天数不能为空',
      table: {
        ruleId: '规则ID',
        ruleName: '规则名称',
        cycleDays: '周期天数',
        rewardAmount: '奖励积分',
        extraRewardAmount: '额外奖励积分',
        remark: '签到说明'
      },
      placeholder: {
        ruleName: '请输入规则名称',
        cycleDays: '请输入周期天数',
        rewardAmount: '请输入奖励积分',
        extraRewardAmount: '请输入额外奖励积分',
        remark: '请输入签到说明'
      }
    },
    signAccount: {
      title: '签到账户管理',
      queryCondition: '查询条件',
      table: {
        accountId: '账户ID',
        personId: '用户ID',
        personName: '用户名称',
        totalDays: '累计签到天数',
        continueDays: '连续签到天数',
        lastSignDate: '最后签到日期',
        cycleNum: '当前周期',
        createTime: '创建时间'
      },
      placeholder: {
        personName: '请输入用户名称',
        personId: '请输入用户ID'
      }
    },
    signRecord: {
      title: '签到记录管理',
      queryCondition: '查询条件',
      table: {
        recordId: '记录ID',
        accountId: '账户ID',
        personId: '用户ID',
        personName: '用户名称',
        signDate: '签到日期',
        signType: '签到类型',
        rewardAmount: '获得积分',
        rewardDesc: '奖励描述',
        remark: '备注',
        createTime: '创建时间'
      },
      placeholder: {
        personName: '请输入用户名称',
        personId: '请输入用户ID',
        signDate: '请输入签到日期'
      }
    }
  }
}
